import React from "react";
import { Navigate } from "react-router-dom";

const AdminRoute = ({ children }) => {
  const token = localStorage.getItem("starGoldAdminToken");

  const role = localStorage.getItem("starGoldAdminRole");

  if (!token || role !== "ADMIN") {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
};

export default AdminRoute;
